import {remCalc} from '_themeUtils'
import wallMixedImage from './partials/wallMixedImage'
import wallMixedVideo from './partials/wallMixedVideo'

const wallMixed = {
    WallMixed: {
        baseStyle: ({mobileSideBySide}) => ({
            wallMixedWrapper: {
                w: '100%',
                h: '100%',
                gridColumn: '1 / -1',
                overflow: 'hidden',
            },
            gridContainer: {
                gridColumnGap: '0',
            },
            gridThreeCol: {
                gridColumnGap: {base: remCalc(32), lg: remCalc(60)},
                padding: {base: `${remCalc(16)} ${remCalc(48)}`, lg: '0'},
            },
            gridFourCol: {
                gridColumnGap: {base: remCalc(24), md: remCalc(32)},
                padding: {
                    base: mobileSideBySide ? `${remCalc(24)} ${remCalc(12)}` : `${remCalc(24)} ${remCalc(32)}`,
                    md: `${remCalc(32)} ${remCalc(88)}`,
                    lg: '0',
                },
            },
        }),
    },
}

export default {...wallMixed, ...wallMixedImage, ...wallMixedVideo}
